import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10 text-center">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">⭐ FEATURES</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">特色优势</h2>
          <p className="text-sm text-foreground-500 mt-1">为什么 800 万漫友选择漫漫漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl p-6 text-center hover:bg-background-100 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}